<script>
import T1LanguageTab from "./components/T1LanguageTab.vue";
import T1AcademicTab from "./components/T1AcademicTab.vue";
export default {
    components: {
        T1LanguageTab,
        T1AcademicTab,
    },
    data() {
        return {
            ActiveTab: "",
        };
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
        SetMascot() {
            if (this.ActiveTab == "academic") {
                if (this.Setting.MascotIdAca) {
                    return "background-image: url(https://studentpanel.net/widget/mascots/mascot-" + this.Setting.MascotIdAca + "-min.svg)";
                } else {
                    return "";
                }
            } else if (this.ActiveTab == "language") {
                if (this.Setting.MascotIdLang) {
                    return "background-image: url(https://studentpanel.net/widget/mascots/mascot-" + this.Setting.MascotIdLang + "-min.svg)";
                } else {
                    return "";
                }
            }
        },
    },
    mounted() {
        if (this.Setting.SearchMode === 0) {
            this.ActiveTab = "language";
        } else if (this.Setting.SearchMode === 1) {
            this.ActiveTab = "language";
        } else if (this.Setting.SearchMode === 2) {
            this.ActiveTab = "academic";
        }
    },
};
</script>
<template>
    <div>
        <ul class="nav nav-pills nav-tabs" id="programTab" role="tablist" v-if="this.Setting.SearchMode === 0">
            <li class="nav-item" role="presentation" v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1">
                <button
                    class="nav-link"
                    :class="{active: ActiveTab === 'language'}"
                    @click="ActiveTab = 'language'"
                    id="language-program-tab"
                    type="button"
                    role="tab"
                    aria-controls="language-program"
                    aria-selected="true"
                >
                    {{ this.Setting.LangTitle }}
                </button>
            </li>
            <li class="nav-item" role="presentation" v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2">
                <button
                    class="nav-link"
                    :class="{active: ActiveTab === 'academic'}"
                    @click="ActiveTab = 'academic'"
                    id="academic-program-tab"
                    type="button"
                    role="tab"
                    aria-controls="academic-program"
                    aria-selected="false"
                >
                    {{ this.Setting.AcaTitle }}
                </button>
            </li>
        </ul>
        <div class="tab-content" :style="SetMascot">
            <T1AcademicTab v-if="ActiveTab == 'academic' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2)" />
            <T1LanguageTab v-if="ActiveTab == 'language' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1)" />
        </div>
    </div>
</template>
